import clsx from 'clsx';
import { ReactNode } from 'react';

export const RichTextStyles = ({ children }: { children: ReactNode }) => (
  <div
    className={clsx(
      '[&_h1]:m-0! [&_h1]:text-lg [&_h1]:font-medium', // styles for h1
      '[&_h2]:m-0! [&_h2]:text-base [&_h2]:font-semibold', // styles for h2
      '[&_h3]:m-0! [&_h3]:text-base [&_h3]:font-medium', // styles for h3
      '[&_p]:m-0 [&_p]:text-base [&_p]:leading-6 [&_p]:font-normal', // styles for p
      String.raw`[&_p:empty::before]:content-["\a0"]`, // add a non breaking space inside each empty p so they take up a line
      '[&_li]:my-1 [&_li]:text-base [&_li]:leading-6 [&_li]:font-normal', // styles for li
      '[&_ul]:px-3 [&_ul]:mr-3 [&_ul]:ml-1', // styles for ul
      '[&_ol]:px-3 [&_ol]:mr-3 [&_ol]:ml-1', // styles for ol
    )}
  >
    {children}
  </div>
);
